import { render, staticRenderFns } from "./ChatBannedModalCard.vue?vue&type=template&id=7b665a4b&"
import script from "./ChatBannedModalCard.vue?vue&type=script&lang=js&"
export * from "./ChatBannedModalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports